export const contactSupport = () => {
  if (typeof window.FrontChat === 'undefined') {
    location.href = 'mailto:client.support@wagestream.com';
  } else {
    window.FrontChat('show');
  }
};
